function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f8f8f8",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 22
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.703 36.547V24.74h-3.955v-4.693h3.955v-3.7c0-4.014 2.455-6.2 6.039-6.2a33.205 33.205 0 013.62.186v4.2h-2.486c-1.949 0-2.326.928-2.326 2.284v3.23h4.4l-.6 4.693h-3.802v11.807",
  fill: "#f8f8f8"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NyIgaGVpZ2h0PSI0NyIgdmlld0JveD0iMCAwIDQ3IDQ3Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTExMiAtNDM5MSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTIgNDM5MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Y4ZjhmOCIgc3Ryb2tlLXdpZHRoPSIzIj48Y2lyY2xlIGN4PSIyMy41IiBjeT0iMjMuNSIgcj0iMjMuNSIgc3Ryb2tlPSJub25lIi8+PGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjIyIiBmaWxsPSJub25lIi8+PC9nPjxwYXRoIGQ9Ik0zLjk1NSwyNi40VjE0LjU5M0gwVjkuOUgzLjk1NVY2LjJDMy45NTUsMi4xODYsNi40MSwwLDkuOTk0LDBhMzMuMjA1LDMzLjIwNSwwLDAsMSwzLjYyLjE4NnY0LjJIMTEuMTI4Yy0xLjk0OSwwLTIuMzI2LjkyOC0yLjMyNiwyLjI4NFY5LjloNC40bC0uNiw0LjY5M0g4LjhWMjYuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyOC43NDggNDQwMS4xNDcpIiBmaWxsPSIjZjhmOGY4Ii8+PC9nPjwvc3ZnPg==";
export { SvgFacebook as ReactComponent };